import { connect } from 'react-redux'
import { translate } from 'react-translate'

import HeaderView from './Header.component'
import { loadTranslations } from '../../../actions/app'

const mapStateToProps = (state) => {
  return {
    detail: state.header.details,
    phone: state.header.telephone,
    language: state.app.language
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadTranslations: (l) => {
      dispatch(loadTranslations(l))
      setTimeout(() => {
        // TODO - Remove this. It should not work this way
        dispatch(loadTranslations(l))
        dispatch(loadTranslations(l))
        dispatch(loadTranslations(l))
        dispatch(loadTranslations(l))
      }, 1000)
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate('Header')(HeaderView))



// WEBPACK FOOTER //
// ./src/features/commons/Header/Header.container.js